/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pre-op-check-list.reducer';

export const PreOpCheckList = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const preOpCheckListList = useAppSelector(state => state.preOpCheckList.entities);
  const loading = useAppSelector(state => state.preOpCheckList.loading);
  const totalItems = useAppSelector(state => state.preOpCheckList.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pre-op-check-list-heading" data-cy="PreOpCheckListHeading">
        <Translate contentKey="tinyMedicRestApp.preOpCheckList.home.title">Pre Op Check Lists</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.preOpCheckList.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pre-op-check-list/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.preOpCheckList.home.createLabel">Create new Pre Op Check List</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.preOpCheckList.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {preOpCheckListList && preOpCheckListList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('preparation')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.preparation">Preparation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preparation')} />
                </th>
                <th className="hand" onClick={sort('vitals')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.vitals">Vitals</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vitals')} />
                </th>
                <th className="hand" onClick={sort('amCareSponge')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.amCareSponge">Am Care Sponge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amCareSponge')} />
                </th>
                <th className="hand" onClick={sort('amCareShower')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.amCareShower">Am Care Shower</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amCareShower')} />
                </th>
                <th className="hand" onClick={sort('urinaryTime')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.urinaryTime">Urinary Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('urinaryTime')} />
                </th>
                <th className="hand" onClick={sort('urinaryCatheter')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.urinaryCatheter">Urinary Catheter</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('urinaryCatheter')} />
                </th>
                <th className="hand" onClick={sort('enemaBowlWash')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.enemaBowlWash">Enema Bowl Wash</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('enemaBowlWash')} />
                </th>
                <th className="hand" onClick={sort('enemaLaxatives')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.enemaLaxatives">Enema Laxatives</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('enemaLaxatives')} />
                </th>
                <th className="hand" onClick={sort('preOpMedsGiven')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.preOpMedsGiven">Pre Op Meds Given</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preOpMedsGiven')} />
                </th>
                <th className="hand" onClick={sort('preOpMedsGivenTime')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.preOpMedsGivenTime">Pre Op Meds Given Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preOpMedsGivenTime')} />
                </th>
                <th className="hand" onClick={sort('skinPreparation')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.skinPreparation">Skin Preparation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('skinPreparation')} />
                </th>
                <th className="hand" onClick={sort('nbm')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.nbm">Nbm</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('nbm')} />
                </th>
                <th className="hand" onClick={sort('consent')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.consent">Consent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consent')} />
                </th>
                <th className="hand" onClick={sort('makingOfSite')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.makingOfSite">Making Of Site</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('makingOfSite')} />
                </th>
                <th className="hand" onClick={sort('medicationProfile')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.medicationProfile">Medication Profile</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicationProfile')} />
                </th>
                <th className="hand" onClick={sort('denturesRemoved')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.denturesRemoved">Dentures Removed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('denturesRemoved')} />
                </th>
                <th className="hand" onClick={sort('lensesRemoved')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.lensesRemoved">Lenses Removed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lensesRemoved')} />
                </th>
                <th className="hand" onClick={sort('prostesisRemoved')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.prostesisRemoved">Prostesis Removed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prostesisRemoved')} />
                </th>
                <th className="hand" onClick={sort('prostesisNames')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.prostesisNames">Prostesis Names</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prostesisNames')} />
                </th>
                <th className="hand" onClick={sort('jewelleryRemoved')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.jewelleryRemoved">Jewellery Removed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('jewelleryRemoved')} />
                </th>
                <th className="hand" onClick={sort('highRiskConsent')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.highRiskConsent">High Risk Consent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('highRiskConsent')} />
                </th>
                <th className="hand" onClick={sort('bloodType')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.bloodType">Blood Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodType')} />
                </th>
                <th className="hand" onClick={sort('bloodScreen')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.bloodScreen">Blood Screen</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodScreen')} />
                </th>
                <th className="hand" onClick={sort('bloodHoldReady')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.bloodHoldReady">Blood Hold Ready</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodHoldReady')} />
                </th>
                <th className="hand" onClick={sort('pacDone')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.pacDone">Pac Done</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pacDone')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.anaesthesiologist">Anaesthesiologist</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpCheckList.nurse">Nurse</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {preOpCheckListList.map((preOpCheckList, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pre-op-check-list/${preOpCheckList.id}`} color="link" size="sm">
                      {preOpCheckList.id}
                    </Button>
                  </td>
                  <td>{preOpCheckList.preparation ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.vitals ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.amCareSponge ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.amCareShower ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.urinaryTime}</td>
                  <td>{preOpCheckList.urinaryCatheter ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.enemaBowlWash ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.enemaLaxatives ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.preOpMedsGiven ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.preOpMedsGivenTime}</td>
                  <td>{preOpCheckList.skinPreparation ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.nbm ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.consent ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.makingOfSite ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.medicationProfile ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.denturesRemoved ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.lensesRemoved ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.prostesisRemoved ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.prostesisNames}</td>
                  <td>{preOpCheckList.jewelleryRemoved ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.highRiskConsent ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.bloodType ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.bloodScreen ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.bloodHoldReady ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.pacDone ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.active ? 'true' : 'false'}</td>
                  <td>{preOpCheckList.cursor}</td>
                  <td>{preOpCheckList.lastupdated}</td>
                  <td>{preOpCheckList.microSec}</td>
                  <td>{preOpCheckList.timestampentry}</td>
                  <td>
                    {preOpCheckList.surgery ? (
                      <Link to={`/patient-procedure/${preOpCheckList.surgery.id}`}>{preOpCheckList.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preOpCheckList.anaesthesiologist ? (
                      <Link to={`/doctor/${preOpCheckList.anaesthesiologist.id}`}>{preOpCheckList.anaesthesiologist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{preOpCheckList.nurse ? <Link to={`/nurse/${preOpCheckList.nurse.id}`}>{preOpCheckList.nurse.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pre-op-check-list/${preOpCheckList.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pre-op-check-list/${preOpCheckList.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pre-op-check-list/${preOpCheckList.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.preOpCheckList.home.notFound">No Pre Op Check Lists found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={preOpCheckListList && preOpCheckListList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PreOpCheckList;
